import React, {useEffect, useState} from "react";
import {erc20ABI, useAccount, useContractWrite, useNetwork, useWaitForTransaction} from "wagmi";
import {DEFAULT_CHAIN, SWAP_CONTRACTS} from "../../../../chain/constants";
import BigNumber from "bignumber.js";
import {formatUnits, parseUnits} from "viem";
import {shortenHash} from "../../../../utils";

// import {toast, ToastContainer} from "react-toastify";

export default function Approve() {
    const { address: account, isConnected } = useAccount();
    const { chain, chains } = useNetwork();

    const [currentChain, setCurrentChain] = useState(DEFAULT_CHAIN);
    const [swapContract, setSwapContract] = useState(SWAP_CONTRACTS[DEFAULT_CHAIN.id]);
    useEffect(() => {
        let _currentChain = DEFAULT_CHAIN;
        if (isConnected && chain?.id && chains.findIndex(c => c.id === chain.id) > -1) {
            _currentChain = chain;
        }
        setCurrentChain(_currentChain);
        if (_currentChain.id in SWAP_CONTRACTS) {
            setSwapContract(SWAP_CONTRACTS[_currentChain.id]);
        } else {
            setSwapContract(undefined);
        }
    }, [isConnected, chain, chains]);

    const [amount, setAmount] = useState('');

    const { data: writeResult, isLoading: isLoadingWrite, isSuccess: isSuccessWrite, isError: isErrorWrite, write, reset } = useContractWrite({
        chainId: swapContract?.v2Token?.chainId,
        address: swapContract?.v2Token?.address,
        abi: erc20ABI,
        functionName: 'approve',
        args: [
            swapContract?.upgradeAddress,
            parseUnits(amount, swapContract?.v2Token?.decimals),
            // BigNumber(amount).shiftedBy(swapContract?.v2Token?.decimals || 0).toFixed(),
        ],
        onError: (err) => {
            console.log('tx.write.err', err);
        }
    });
    useEffect(() => {
        console.log('approve.write', { isError: isErrorWrite, isLoading: isLoadingWrite, isSuccess: isSuccessWrite, data: writeResult });
        // console.log('approve.tx', {
        //     chainId: swapContract?.v2Token?.chainId,
        //     address: swapContract?.v2Token?.address,
        //     abi: erc20ABI,
        //     functionName: 'approve',
        //     args: [
        //         swapContract?.upgradeAddress,
        //         BigNumber(amount).shiftedBy(swapContract?.v2Token?.decimals || 0).toFixed(),
        //     ],
        // });
    }, [isErrorWrite, isLoadingWrite, isSuccessWrite, writeResult]);

    // const { data: waitResult, isIdle: isIdleWait, isLoading: isLoadingWait, isFetching: isFetchingWait, isSuccess: isSuccessWait, isError: isErrorWait, status: statusWait }
    const { isLoading: isLoadingWait, isSuccess: isSuccessWait, isError: isErrorWait } = useWaitForTransaction({
        hash: writeResult?.hash,
        enabled: isSuccessWrite,
    });
    useEffect(() => console.log('approve.wait', { isLoading: isLoadingWait, isSuccess: isSuccessWait, isError: isErrorWait }), [isLoadingWait, isSuccessWait, isErrorWait]);

    useEffect(() => {
        reset();
    }, [chain?.id, reset]);

    // useEffect(() => {
    //     if (isSuccessWait) {
    //         toast('Successfully approved', { type: 'success' });
    //     } else if (isErrorWait) {
    //         toast('Failed to approve', { type: 'success' });
    //     }
    // }, [isErrorWait, isSuccessWait]);

    return (<div className="card">
        <div className="card-header d-sm-flex d-block pb-0 border-0">
            <div className="mb-3">
                <h4 className="fs-20 text-black">Quick Approve</h4>
                <p className="mb-0 fs-12">Please set the amount available for swapping.</p>
            </div>
            {/*<Dropdown className="custom-dropdown d-block mt-3 mt-sm-0 mb-0">*/}
            {/*	<Dropdown.Toggle variant="" className="btn btn-light btn-sm d-flex align-items-center svg-btn i-false" data-toggle="dropdown">*/}
            {/*		<svg className="me-2" width="25" height="25" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
            {/*			<path d="M21 0C9.40213 0 0.00012207 9.40201 0.00012207 20.9999C0.00012207 32.5978 9.40213 41.9998 21 41.9998C32.5979 41.9998 41.9999 32.5978 41.9999 20.9999C41.9867 9.4075 32.5924 0.0132751 21 0ZM28.5 31.5001H16.5002C15.6717 31.5001 15.0001 30.8286 15.0001 30C15.0001 29.929 15.0052 29.8581 15.0152 29.7876L16.1441 21.8843L13.864 22.4547C13.7449 22.4849 13.6227 22.5 13.5 22.5C12.6715 22.4991 12.0009 21.8271 12.0013 20.9985C12.0022 20.311 12.4701 19.7122 13.137 19.5447L16.6018 18.6786L18.015 8.78723C18.1321 7.96692 18.892 7.39746 19.7123 7.51465C20.5327 7.63184 21.1021 8.39172 20.9849 9.21204L19.7444 17.8931L25.1364 16.545C25.9388 16.3403 26.755 16.8251 26.9592 17.6276C27.1638 18.43 26.679 19.2462 25.8766 19.4508C25.872 19.4518 25.8674 19.4531 25.8629 19.454L19.2857 21.0983L18.2287 28.4999H28.5C29.3286 28.4999 30.0001 29.1714 30.0001 30C30.0001 30.8281 29.3286 31.5001 28.5 31.5001Z" fill="#5974D5"/>*/}
            {/*		</svg>*/}
            {/*		<span className="text-black fs-16">23,511 LTC</span>*/}
            {/*		<i className="fa fa-angle-down text-black scale3 ms-2"></i>*/}
            {/*	</Dropdown.Toggle>*/}
            {/*	<Dropdown.Menu className="dropdown-menu-right" alignRight={true}>*/}
            {/*		<Link className="dropdown-item" to="#">345,455 ETH</Link>*/}
            {/*		<Link className="dropdown-item" to="#">789,123 BTH</Link>*/}
            {/*	</Dropdown.Menu>*/}
            {/*</Dropdown>*/}
        </div>
        <div className="card-body" style={{ height: 468 }}>
            <div className="form-wrapper">
                <div className="form-group">
                    <div className="input-group input-group-lg">
                        <div className="input-group-prepend">
                            <span className="input-group-text">D-Wallet Token</span>
                        </div>
                        <input type="text" className="form-control" readOnly value={swapContract?.v2Token?.address} />
                    </div>
                </div>
            </div>
            <div className="form-wrapper">
                <div className="form-group">
                    <div className="input-group input-group-lg">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Owner</span>
                        </div>
                        <input type="text" className="form-control" readOnly value={account} />
                    </div>
                </div>
            </div>
            <div className="form-wrapper">
                <div className="form-group">
                    <div className="input-group input-group-lg">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Spender</span>
                        </div>
                        <input type="text" className="form-control" readOnly value={swapContract?.upgradeAddress} />
                    </div>
                </div>
            </div>
            <div className="form-wrapper">
                <div className="form-group">
                    <div className="input-group input-group-lg">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Amount DWT</span>
                        </div>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="0.0"
                            value={amount}
                            onChange={e => setAmount(e.target.value)}
                            onBlur={e => setAmount(Number(e.target.value) > 0 ? formatUnits(parseUnits(BigNumber(e.target.value).toString(10), swapContract?.v2Token?.decimals), swapContract?.v2Token?.decimals) : '')}
                        />
                    </div>
                </div>
            </div>
            <div className="row pt-5 align-items-center">
                {/*<div className="col-sm-6 mb-2">*/}
                {/*    <p className="mb-0 fs-14">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>*/}
                {/*</div>*/}
                <div className="col-sm-12 mb-2">
                    <button
                        className="btn btn-secondary d-block w-100"
                        disabled={!isConnected || !swapContract || !(Number(amount) > 0) || isLoadingWrite}
                        onClick={() => write()}
                    >
                        APPROVE NOW
                    </button>
                    {isSuccessWait ? <p className="mt-2 mb-0 text-success">Approved successfully:{' '}<a
                        href={`${currentChain?.blockExplorers?.default.url}/tx/${writeResult?.hash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-link"
                    >
                        {shortenHash(writeResult?.hash)}
                    </a></p> : isSuccessWrite ? <p className="mt-2 mb-0">
                        The tx has been sent:{' '}
                        <a
                            href={`${currentChain?.blockExplorers?.default.url}/tx/${writeResult?.hash}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-link"
                        >
                            {shortenHash(writeResult?.hash)}
                        </a>
                    </p> : <p style={{ height: 25.2 }}></p>}
                </div>
            </div>
        </div>
        {/*<ToastContainer />*/}
    </div>);
}
